import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetworkCallService } from './services/network-call.service';
import { HelpersService } from './services/helpers.service';
import { BreadcrumbRoutesControlService } from './services/breadcrumb-routes-control.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './services/token.interceptor';
import { CheckPermissionDirective } from './directives/check-permission-directive.directive';
import { CustomAutofocusDirective } from './directives/custom-autofocus.directive';
import { LoaderService } from './services/loader-service.service';
import { LottieLoaderInterceptor } from './services/lottie-loader.interceptor';
import { UnauthorizedInterceptor } from './services/unauthorized.interceptor';
import { WithLoadingPipe } from './pipes/with-loading.pipe';
import { CheckOneLegalEntityExistsService } from './services/check-one-legal-entity-exists.service';

@NgModule({
  declarations: [CheckPermissionDirective, CustomAutofocusDirective, WithLoadingPipe],
  providers: [
    LoaderService,
    NetworkCallService,
    HelpersService,
    CheckOneLegalEntityExistsService,
    BreadcrumbRoutesControlService,
    {
      provide: APP_INITIALIZER,
      useFactory: (brcs: BreadcrumbRoutesControlService) => () => true,
      deps: [BreadcrumbRoutesControlService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LottieLoaderInterceptor,
      multi: true
    }
  ],
  imports: [CommonModule],
  exports: [CheckPermissionDirective, CustomAutofocusDirective, WithLoadingPipe]
})
export class CoreModule {}
